import { Alert, Typography } from '@mui/material';

import React from 'react';
import { COLOR_SHOWRUNNR_AI } from '../../../common/Colors';
import CustomSkeleton from '../../../common/components/CustomSkeleton';
import I18n from '../../../common/i18n/I18n';
import { Icons } from '../../../common/icons/Icons';
import { H, V } from '../../../common/Layout';

interface LeadAIProcessingPropsType {
    contentToken: string;
}

export default (props: LeadAIProcessingPropsType) => {
    const { contentToken } = props;

    return (
        <V gap={2} sx={{ p: 2 }}>
            <Alert severity="info" sx={{ width: '100%', alignItems: 'center' }}>
                <Typography>
                    <I18n token={contentToken} />
                </Typography>
            </Alert>
            <H sx={{ alignItems: 'flex-start', justifyContent: 'flex-start', marginLeft: 1 }} gap={1}>
                <Icons.AutoAwesomeGradient />
                <V>
                    <CustomSkeleton width={'30%'} sx={{ background: COLOR_SHOWRUNNR_AI, opacity: 0.2 }} />
                    <CustomSkeleton width={'50%'} sx={{ background: COLOR_SHOWRUNNR_AI, opacity: 0.2 }} />
                    <CustomSkeleton width={'100%'} sx={{ background: COLOR_SHOWRUNNR_AI, opacity: 0.2 }} />
                </V>
            </H>
        </V>
    );
};
